import * as React from 'react'

const KEYS = {
	8: 'onBackspace',
	9: 'onTab',
	13: 'onEnter',
	27: 'onEsc',
	32: 'onSpace',
	37: 'onLeft',
	38: 'onUp',
	39: 'onRight',
	40: 'onDown',
	188: 'onComma',
	16: 'onShift'
}

type Props = any & {
	children?: any
	target?: any
	onKeyDown?: (e: KeyboardEvent, ...any) => void
}

class Keyboard extends React.Component<Props> {

	componentDidMount() {
		const { target } = this.props
		if (target === 'document' || !target) {
			document.addEventListener('keydown', this.onKeyDown)
		}
	}

	componentWillUnmount() {
		const { target } = this.props
		if (target === 'document' || !target) {
			document.removeEventListener('keydown', this.onKeyDown)
		}
	}

	onKeyDown = (e: KeyboardEvent, ...rest) => {
		const { onKeyDown } = this.props
		const key = e.keyCode ? e.keyCode : e.which
		const callbackName = KEYS[key]

		/* eslint-disable react/destructuring-assignment */
		if (callbackName && this.props[callbackName]) {
			this.props[callbackName](e, ...rest)
		}

		/* eslint-enable react/destructuring-assignment */
		if (onKeyDown) {
			onKeyDown(e, ...rest)
		}
	}

	render() {
		const { children, target } = this.props

		return (target === 'document' || !target) ? children : (
			React.cloneElement(React.Children.only(children), {
				onKeyDown: this.onKeyDown
			})
		)
	}
}

export { Keyboard }
